import { TbInfoCircle } from "react-icons/tb";
import {
  EMPTY_PLATFORM_SUMMARY,
  PlatformStreakStats,
  platformSummaryToStreakStats,
} from "../../constants/dashboardStats";
import "./PlatformStreakIndicator.scss";

type PlatformStreakIndicatorProps = {
  stats?: PlatformStreakStats;
};

const formatDays = (count: number) => `${count} ${count === 1 ? "day" : "days"}`;

const PlatformStreakIndicator = ({
  stats = platformSummaryToStreakStats(EMPTY_PLATFORM_SUMMARY),
}: PlatformStreakIndicatorProps) => {
  const { current, best } = stats;
  const isPersonalBest = current > 0 && current === best;

  return (
    <div
      className={`platform-streak-indicator${
        isPersonalBest ? " platform-streak-indicator--best" : ""
      }`}
    >
      <span className="platform-streak-indicator__label">Platform streak</span>
      <span className="platform-streak-indicator__value">
        {formatDays(current)} 🔥
      </span>
      <span className="platform-streak-indicator__meta">
        {isPersonalBest ? "Personal best!" : `Best: ${formatDays(best)}`}
      </span>
      <div className="platform-streak-indicator__info-wrap">
        <button
          type="button"
          className="platform-streak-indicator__info"
          aria-describedby="platform-streak-tooltip"
        >
          <TbInfoCircle aria-hidden="true" />
        </button>
        <div
          id="platform-streak-tooltip"
          className="platform-streak-indicator__tooltip"
          role="tooltip"
        >
          Your platform streak is how many days in a row you&apos;ve answered questions, across any
          question bank. Your all-time best is {formatDays(best)}.
          {isPersonalBest ? " You're on your all-time best streak right now." : null} Streaks on the
          statistics page are tracked separately for each question bank.
        </div>
      </div>
    </div>
  );
};

export default PlatformStreakIndicator;
